import { routes } from "@/global/routes";
import { TopNavMenuItems } from "./helpers";
import { vendorUUIDs } from "../../constants";
import { faqs, howItWorks, purchaseSeatsLanguages } from "./helpers";
import {
  DefaultRegistrationTerms,
  DefaultCheckoutTerms,
} from "../../default_terms_and_conditions";

import AuthBgBanner from "public/images/pistons/pistons.jpg";
import LogoImage from "public/images/pistons/detroit-pistons-logo.png";
import SeatMap3dPreview from "public/images/pistons/pistons_3d_venue.png";
import FindGamesBanner from "public/images/pistons/PushtothePlayoffs_Seasonshare.png";

import type { TeamConfig } from "../types";

const config: TeamConfig = {
  teamSchema: "pistons_flex",
  browserTitle: "Pistons 3 Game Push To The Playoffs",
  // packages: true,
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "(248) 377-0100",
  manageCard: true,
  teamName: "Detroit Pistons",

  // Standard one
  // dynamicPricing: {
  //   enabled: true,
  //   list: [
  //     {
  //       id: 1,
  //       minSelectedAmount: 7,
  //       updatedAccountGroup: 0,
  //       discount: 0,
  //     },
  //     {
  //       id: 2,
  //       minSelectedAmount: 10,
  //       updatedAccountGroup: 1,
  //       discount: 10,
  //       customAditionalMessage: " to receive additional savings?",
  //     },
  //   ],
  // },

  // Temporary one
  dynamicPricing: {
    showAllDiscounts: true,
    enabled: true,
    list: [
      {
        id: 1,
        discount: 5,
        minSelectedAmount: 3,
        updatedAccountGroup: 2,
        customProgressBarMessage:
          "Congrats! You've unlocked 5% off your tickets. Add more games or checkout now.",
      },
    ],
  },

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-00064-pistons-sec",
    mapId: "main",
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.purchaseSeats,
  },

  // disabled routes
  disabledRoutes: [routes.giftCard],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: true,
  inventoryType: "SEAT-LEVEL",

  // purchase seat configs
  purchaseSeatConfigs: {
    // minGameSelectionCount: 7, standard one
    // minSeatLimit: 1, standard one
    minGameSelectionCount: 3, // temporary one
    minSeatLimit: 2, // temporary one
    isSimilarSeatForAllEvents: true,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,
    checkoutTimerEnabled: false,
    showFrontendTotalAmount: true,
    showFrontendServiceFee: true,
    hideViewTicketsInThankYouPage: true,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    // standard one
    // staticBuildYourOwn: {
    //   minEventSelectionCount: 7,
    //   title: "Build Your Own",
    //   description: "Select 7 or more games to create your own package.",
    //   displayBuildYourOwnOnTop: true,
    // },
    // temporary one
    staticBuildYourOwn: {
      minEventSelectionCount: 3,
      title: "Build Your Own",
      description: "Select 3 or more games to create your own package.",
      displayBuildYourOwnOnTop: true,
    },
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
    checkoutTimerEnabled: false,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: 3,
    allowedPaymentFailCount: 3,
  },
  isSaveCardAllowed: true,

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "ec49f9fb-f0f2-4340-ae85-32fbeeab88d1",
    beaconId: "pistonssports",
    amazonPixelId: "9fdf4fbd-9154-4e73-9881-28fc480ea124",
    amazonTrackingEvent: "CHECKOUT_Detroit Pistons Basketball landing IHM 295",
    metaPixelId: "265988502922405",
  },

  // call refresh inventory when selecting games
  refreshInventoryWhenEventClick: false,

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/pistons/",

  // vendor
  platform: vendorUUIDs.ticketmaster,

  // okta config
  oktaIssuer: "",
  oktaClientId: "",

  // images
  images: {
    findGamesBannerImage: FindGamesBanner.src,
    authBackgroundImage: AuthBgBanner.src,
    checkoutStatusPageImage: AuthBgBanner.src,
    logoImage: LogoImage.src + "?width=76&height=76",
    logoNameImage: "",
    faviconImage:
      "https://ss-leagues.s3.amazonaws.com/NBA%2023-24%20Logos/Detroit%20Pistons%20.svg",
    seatMap3dPreviewImage: SeatMap3dPreview.src,
  },

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },

    featuredGameCard: {
      showLogoWithTitle: true,
      hideOverlayLogo: true,
    },
    bottomBar: {
      showGameSelectionProgress: true,
    },

    hideCheckoutCartBalance: false,

    manageCard: {
      showPageTitle: false,
    },
  },

  colors: {
    primary: "#1d4699",
  },

  howItWorks,
  faqs,

  languages: {
    topNavMenuItems: <TopNavMenuItems />,
    checkoutTermsAndCondition: <DefaultCheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    purchaseSeats: purchaseSeatsLanguages,
    purchaseGiftCard: null,
    redeemGiftCard: null,
    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description:
              "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift card, they will be prompted to enter their unique code to redeem the gift card. They can use the gift card for all events at the Hippodrome Broadway Series in Baltimore, Maryland.",
          },
          sendNowTrue: {
            description:
              "The Recipient will be sent an email with the unique code for them to redeem their gift card. They can use the gift card for all events at the Hippodrome Broadway Series in Baltimore, Maryland.",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description:
            "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster account above.",
        },
        logout: {
          description:
            "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster.",
        },
        success: {
          description: "has been added to to your account!",
        },
      },
    },
    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
